/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetItemQuery } from '../../models/get-item-query';
import { GetItemQueryResult } from '../../models/get-item-query-result';

export interface ApiNurseryManagerItemsGetItemPost$Params {
      body?: GetItemQuery
}

export function apiNurseryManagerItemsGetItemPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerItemsGetItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerItemsGetItemPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetItemQueryResult>;
    })
  );
}

apiNurseryManagerItemsGetItemPost.PATH = '/api/NurseryManager/Items/GetItem';
